// @flow
import React, { Component, type ComponentType } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";

import { ModalOverlay, Modal, ModalContent, CloseButton } from "./styled";

type Props = {|
    onHide: Function,
    children: ComponentType<any>,
    showCloseButton: boolean
|};

const stack = [];

class Dialog extends Component<Props> {
    // Init of the component before it is mounted.
    constructor(props) {
        super(props);

        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.outerId = `my-modal-${new Date().getTime()}`;
    }

    // Add listeners immediately after the component is mounted.
    componentDidMount() {
        stack.unshift(this.outerId);
        window.addEventListener("keyup", this.handleKeyUp, false);
        this.toggleScrollLock(true);
    }

    // Remove listeners immediately before a component is unmounted and destroyed.
    componentWillUnmount() {
        stack.shift(this.outerId);
        window.removeEventListener("keyup", this.handleKeyUp, false);
        this.toggleScrollLock(false);
    }

    // Handle the key press event.
    handleKeyUp(e) {
        if (this.outerId === stack[0]) {
            const keys = {
                27: () => {
                    e.preventDefault();
                    this.props.onHide();
                    window.removeEventListener("keyup", this.handleKeyUp, false);
                }
            };

            if (keys[e.keyCode]) {
                keys[e.keyCode]();
            }
        }
    }

    // Handle the mouse click on browser window.
    handleOutsideClick(e) {
        if (e.target.id === stack[0]) {
            this.props.onHide();
            document.removeEventListener("click", this.handleOutsideClick, false);
        }
        e.stopPropagation();
    }

    toggleScrollLock = lock => {
        const modal = document.getElementById(this.outerId);
        if (modal !== null) {
            if (lock) {
                disableBodyScroll(modal);
            } else {
                enableBodyScroll(modal);
            }
        }
    };

    render() {
        const { children, onHide, showCloseButton } = this.props;
        return (
            <ModalOverlay id={this.outerId} onClick={this.handleOutsideClick}>
                <Modal onClick={this.handleOutsideClick}>
                    {(showCloseButton === undefined || showCloseButton) && (
                        <CloseButton>
                            <Button
                                onClick={onHide}
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                    position: "absolute",
                                    top: 20,
                                    left: 20
                                }}
                                variant="fab"
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </Button>
                        </CloseButton>
                    )}
                    <ModalContent onClick={this.handleOutsideClick}>{children}</ModalContent>
                </Modal>
            </ModalOverlay>
        );
    }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/dialog/InternalDialog.js